import './App.css'
import { useEffect, useState } from 'react'
import logo from './images/bitmovin-logo.png'
import BitmovinPlayer from './bitmovinPlayer'

const ADS_MODULE_URL =
  'https://cdn.bitmovin.com/player/web/8/modules/bitmovinplayer-advertising-bitmovin.js'

function loadScriptOnce(src) {
  return new Promise((resolve, reject) => {
    // already present?
    const existing = document.querySelector(`script[src="${src}"]`)
    if (existing) {
      if (existing.dataset.loaded === 'true') return resolve()
      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true })
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.type = 'text/javascript'

    script.addEventListener('load', () => {
      script.dataset.loaded = 'true'
      resolve()
    })
    script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)))

    document.head.appendChild(script)
  })
}

function App() {
  const [adsModuleReady, setAdsModuleReady] = useState(false)
  const [adsModuleError, setAdsModuleError] = useState(null)

  useEffect(() => {
    let cancelled = false

    loadScriptOnce(ADS_MODULE_URL)
      .then(() => {
        if (!cancelled) setAdsModuleReady(true)
      })
      .catch((e) => {
        if (!cancelled) setAdsModuleError(e?.message || 'Failed to load advertising module')
      })

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="app">
      <div id="wrapper">
        <div id="banner">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="title">
            <h1>React JS - Monolith Player</h1>
          </div>
          <div className="clear" />
        </div>

        <div className="container">
          <h1>HTML5 Adaptive Streaming Player for MPEG-DASH &amp; HLS</h1>
          <h2>Your videos play everywhere with low startup delay, no buffering and in highest quality.</h2>

          <div className="content">
            <div id="player-wrapper">
              {adsModuleError ? (
                <div style={{ padding: 12 }}>
                  <strong>Advertising module failed to load:</strong> {adsModuleError}
                  <div style={{ marginTop: 8 }}>
                    (Player not rendered so we don’t init Bitmovin without the ads module.)
                  </div>
                </div>
              ) : adsModuleReady ? (
                <BitmovinPlayer />
              ) : (
                <div style={{ padding: 12 }}>Loading advertising module…</div>
              )}
            </div>

            <div className="description">
              <p>
                For more information about the bitmovin player, please have a look at our online{' '}
                <a href="//bitmovin.com/support" target="_blank" rel="noreferrer">
                  Developer Section
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
